export function semanticTagsNamespace(http) {
    return {
        /** List tags → unwraps to the tag array. */
        list(params = {}) {
            const { signal, ...query } = params;
            return http.get('/semantic-tags', { query, signal });
        },
        /** Create a tag → unwraps to the tag; throws on validation failure. */
        create(body) {
            return http.post('/semantic-tags', { body });
        },
        /** Update a tag → unwraps to the tag; throws on validation failure. */
        update(id, body) {
            return http.put(`/semantic-tags/${id}`, { body });
        },
        /** Delete a tag. Throws on failure. */
        delete(id) {
            return http.delete(`/semantic-tags/${id}`);
        },
        /** Replace a resource's tag set → unwraps to the resulting tag array. */
        syncResource(resourceId, tagIds) {
            return http.put(`/resources/${resourceId}/semantic-tags`, { body: { tag_ids: tagIds } });
        },
    };
}
//# sourceMappingURL=semantic-tags.js.map